import { IMG, STORY_CHAPTERS, BRAND } from "../lib/site";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { RequestQuoteButton, AskExpertButton } from "../components/Buttons";

export default function Story() {
  return (
    <div data-testid="story-page" className="bg-bb-bg">
      <PageHero
        eyebrow="[ Since 2014 ]"
        title="Our Story"
        image={IMG.sunriseField}
        alt="Delaware Basin oilfield at sunrise"
        testid="story-hero"
      />

      {/* Giant year intro */}
      <section className="py-20 md:py-28 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-5">
            <span className="font-display text-bb-gold text-[7rem] sm:text-[10rem] md:text-[13rem] leading-none block">
              2014
            </span>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-bb-silver/80 text-xl md:text-2xl leading-relaxed">
              Big Buck Services began in Carlsbad, New Mexico, the heart of the
              Delaware Basin, with{" "}
              <span className="text-bb-gold">a single truck</span> and the belief
              that doing the work right, every time, is a business plan you can
              build on.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Chapters */}
      <section className="py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-5 md:px-10">
          {STORY_CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div
                data-testid={`story-chapter-${i}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-white/10 group"
              >
                <div className="md:col-span-3 flex items-start gap-4">
                  <span className="font-mono2 text-bb-gold text-sm">
                    {c.num}
                  </span>
                  <span className="hidden md:block h-px flex-1 mt-2.5 bg-white/10 group-hover:bg-bb-gold/50 transition-colors duration-500" />
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-display uppercase text-3xl md:text-5xl text-bb-silver leading-[0.95] mb-4">
                    {c.heading}
                  </h3>
                  <p className="text-bb-silver/70 text-lg leading-relaxed max-w-2xl">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Owner accountability pull-quote */}
      <section className="relative py-24 md:py-36 overflow-hidden grain border-t border-white/10">
        <div className="absolute inset-0 z-0">
          <img src={IMG.duskTruck} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-bb-bg/85" />
        </div>
        <div className="max-w-5xl mx-auto px-5 md:px-10 text-center">
          <Reveal>
            <img
              src={BRAND.shield}
              alt="Big Buck Services shield"
              className="mx-auto w-20 mb-8 opacity-90"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-display uppercase text-3xl sm:text-5xl md:text-6xl text-bb-silver leading-[0.95]">
              When it matters, you get the{" "}
              <span className="text-bb-gold">owner</span> on the line. Not a call
              center.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <RequestQuoteButton size="lg" testid="story-request-quote-btn" />
              <AskExpertButton size="lg" testid="story-ask-expert-btn" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
